module.exports = __webpack_public_path__ + "61476bde4d9d0e6837f95207a8f88d2e.woff2";